<template>
  <v-app>
    <loading
      :active.sync="isLoading"
      background-color="#ababab"
      color="#330066"
      loader="spinner"
    />
  
    <v-snackbar
      v-model="snackbar.show"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      right
      multi-line
      top
    >
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          v-bind="attrs"
          text
          @click="snackbar.show = false"
        >{{ 'close' }}</v-btn>
      </template>
    </v-snackbar>
  
    <v-dialog
      v-model="loadingDialog.show"
      :hide-overlay="loadingDialog.hideOverlay"
      width="400"
    >
      <v-card
        :color="loadingDialog.color"
        dark
      >
        <v-card-text class="pt-2">
          {{ loadingDialog.message }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0 mt-1"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <app-navigation v-if="!hideNavigation" />

    <v-col class="main-background">
      <!--
      <v-flex
        v-if="tc.activeChannels.length"
        class="v-content"
        style="padding-left: 56px; height: 44px"
      >
        <v-layout>
          <v-chip-group
            :show-arrows="true"
            style="width: calc(100vw - 400px)"
          >
            <v-chip
              v-for="channel in tc.activeChannels"
              :key="channel.sid"
              close
              :color="colorForChannel(channel)"
              @click:close="closeChannel(channel)"
              @click="driverChannelSelected(channel)"
            >
              {{ channel.friendlyName }}
            </v-chip>
          </v-chip-group>
        </v-layout>
      </v-flex>
-->
      <v-content
        id="main"
        transition="slide-x-transition"
        class="pt-2"
      >
        <router-view exa />
      </v-content>
    </v-col>
    <div id="whoLogged">
      {{ name }}
    </div>
    <audio
      id="ding"
      src="/sound/ding.wav"
    >
      Your browser does not support the
      <code>audio</code> element.
    </audio>
    <div>
      <beautiful-chat
        v-if="openChat && loggedIn"
        :is-open="openChat"
        :participants="[]"
        :message-list="messageList"
        :open="openChatFromBeautifulChat"
        :close="closeChat"
        :show-launcher="false"
        :edit="null"
        :on-message-was-sent="messageSent"
        :always-scroll-to-bottom="true"
        :colors="colors"
        @scrollToTop="scrollToTop"
      >
        <!-- <template v-slot:text-message-body="{ message }">
          <p style="color: black;">{{message.data.text}}</p>
        </template>-->
        <template v-slot:header>
          <h3 style="height: 32px; padding-top: 12px">
            {{
              tc.currentChannel != null
                ? tc.currentChannel.friendlyName
                : ""
            }}
          </h3>
        </template>
      </beautiful-chat>
    </div>
  </v-app>
</template>

<script>

import {replaceStart} from "@/components/util/PhoneNumbers.js";

import AppNavigation from "@/components/AppNavigation";
import Loading from "vue-loading-overlay";

import MessageAllDriversDialog from "@/components/widget/menu/MessageAllDriversDialog.vue";

import "vue-loading-overlay/dist/vue-loading.css";

import qs from "qs";
import axios from "axios";
import { mapState } from 'vuex'

axios.defaults.withCredentials = true;

import moment from "moment";

export default {
  name: "DashboardLayout",
  components: {
    AppNavigation,
    Loading,
    MessageAllDriversDialog,
  },
  data: function () {
    return {
      loadedChats: false,
      hideNavigation: false,
      contactNumberMap: null,
      onlineOnly: false,
      filter: "",
      menu: false,
      fullPage: true,
      openChat: false,
      accessToken: null,
      tc: {
        subscribedChannels: [],
        currentChannel: null,
        currentChannelMessages: null,
        activeChannels: [],
        localChannels: [],
      },
      prefix: "",
      messageList: [],
      twilioMessageList: [],
      identity: "",
      colors: {
        header: {
          bg: "#000000",
          text: "#ffffff",
        },
        launcher: {
          bg: "#000000",
        },
        messageList: {
          bg: "#ffffff",
        },
        sentMessage: {
          bg: "#4e8cff",
          text: "#ffffff",
        },
        receivedMessage: {
          bg: "#eaeaea",
          text: "#222222",
        },
        userInput: {
          bg: "#f4f7f9",
          text: "#565867",
        },
      },
      messageDialog: false,
      activeDriverIDS: [],
      driversIDToContactNumber: {}
    };
  },
  computed: {
    authUser () {
      return this.$store.state.authUser
    },
    chatOpenedBy () {
      return this.$store.getters['messaging/getChatOpenedBy']
    },
    snackbar () {
      return this.$store.getters['snackbar']
    },
    availabilityCenter () {
      return this.$store.getters['availabilityRegion/getCenter']
    },
    currentChannel () {
      return this.$store.getters['messaging/getCurrentChannel']
    },
    selectedDriverChannel () {
      return this.$store.getters['messaging/getSelectedDriverChannel']
    },
    isOpenChat () {
      return this.$store.getters['messaging/getIsOpenChat']
    },
    closingChannel () {
      return this.$store.getters['messaging/getClosingChannel']
    },
    loadingDialog() {
      return this.$store.getters['loadingDialog']
    },
    loggedIn: function () {
      return this.$store.getters.getLoggedIn;
    },
    name: function () {
      return this.$store.getters.getName;
    },
    isLoading: function () {
      return this.$store.state.loading;
    },
    driverToMessage: function () {
      return this.$store.state.driverToMessage;
    },
    localChannelsFiltered: function () {
      var filter = this.filter;
      
      var activeDriverIDS = this.activeDriverIDS;
      return this.tc.localChannels
        .filter(function (f) {
          if (filter == null || filter.length == 0) {
            return activeDriverIDS.indexOf(f.sid) > -1;
          }
          
          return (
            activeDriverIDS.indexOf(f.sid) > -1 &&
            f.friendlyName.toLowerCase().includes(filter.toLowerCase())
          );
        })
        .sort(function (a, b) {
          return a.friendlyName
            .split(" ")[1]
            .localeCompare(b.friendlyName.split(" ")[1]);
        });
    },
    
  },
  watch: {
    "tc.activeChannels" () {
      this.$store.commit('messaging/setActiveChannels', this.tc.activeChannels)
    },
    /*
        isOpenChat () {
          if (!this.isOpenChat) {
            this.openChat = false
            this.closeChannel(this.closingChannel)
          }
        },
    */
    closingChannel () {
      this.openChat = false
      this.closeChannel(this.closingChannel)
    },
    selectedDriverChannel () {
      if (this.selectedDriverChannel != null) {
        this.driverChannelSelected(this.selectedDriverChannel)
        this.$store.commit('messaging/setSelectedDriverChannel', null)
      }
    },
    async driverToMessage(newDriver, oldDriver) {
      this.loadDriverChats(newDriver)
    },
  },
  beforeMount() {
    document.title = "MRC Dispatch";
    this.$store.state.apiUrl = localStorage.getItem("apiUrl");
    this.$store.dispatch("checkAuth");
  },
  mounted: function () {
    this.fetchCenter()
    this.fetchDispatchConfiguration()
    this.$store.state.driverToMessage = null;
    this.fetchAccessToken();
    this.fetchActiveDriverIds();
  },
  methods: {
    async loadDriverChats(newDriver) {
      if (newDriver != null) {
        this.openChat = true;
        var self = this;
        await this.tc.messagingClient
          .getConversationByUniqueName(this.prefix + newDriver)
          .then(function (c) {
            console.log("GOT UNIQUE CHANNEL");
            console.log(c);
            self.tc.currentChannel = c;
            
            if (
              !self.tc.activeChannels.some(function (activeChannel) {
                return activeChannel.sid == c.sid;
              })
            ) {
              self.tc.activeChannels.push(c);
              console.log("Newly active channel");
            }
            
            c.getMessages(15).then(function (messages) {
              self.tc.currentChannelMessages = messages;
              
              c.setAllMessagesRead();
              
              console.log(messages);
              
              var ml = [];
              self.twilioMessageList = []
              for (var i = 0; i < messages.items.length; i++) {
                var msg = messages.items[i];
                self.twilioMessageList.push(msg)
                ml.push({
                  author: msg.author == self.identity ? "me" : msg.author,
                  type: "text",
                  id: msg.sid,
                  data: {
                    text: msg.body,
                    meta: self.getMetaString(msg)
                  },
                  index: msg.index,
                });
              }
              self.messageList = ml;
              console.log(self.messageList);
            });
          }).finally(() => {
            this.loadedChats = false
          });
        this.loadedChats = true
        // if (self.chatOpenedBy) {
        //   console.log('read receipts chat is opened by  ' + self.chatOpenedBy)
        //   await self.addReadReceipt()
        // }
      }
    },
    getMessageAttributes(message) {
      if (message) {
        return message.attributes
      }
    },
    getMetaString(msg) {
      let str = moment(msg.dateCreated).format("YYYY-MM-DD HH:mm")
      let attributes = this.getMessageAttributes(msg)
      if (!attributes) return str;
      if (attributes.seen_by) {
        str += " seen " + attributes.seen_by
      }
      if (attributes.sent_by) {
        str += " sent " + attributes.sent_by
      }
      return str;
    },
    fetchCenter () {
      this.$store.dispatch('availabilityRegion/fetchCenter')
    },
    fetchDispatchConfiguration () {
      this.$store.dispatch('dispatch/getDispatchConfiguration')
    },
    scrollToTop: function () {
      console.log(
        "TOP " + this.messageList[0].index + " " + this.messageList.length
      );
      
      var ml = this.messageList;
      var self = this;
      
      if (this.tc.currentChannelMessages.hasPrevPage) {
        this.tc.currentChannelMessages.prevPage().then(function (messages) {
          self.tc.currentChannelMessages = messages;
          for (var i = 0; i < messages.items.length; i++) {
            var msg = messages.items[i];
            
            ml.unshift({
              author: msg.author == self.identity ? "me" : msg.author,
              type: "text",
              id: msg.sid,
              data: {
                text: msg.body,
                meta: moment(msg.timestamp).format("YYYY-MM-DD HH:mm"),
              },
              index: msg.index,
            });
          }
        });
      }
    },
    formatNumber: function (number) {
      return replaceStart(number);
    },
    messageAllDrivers() {
      this.onlineOnly = false;
      this.messageDialog = true;
    },
    messageOnlineDrivers() {
      this.onlineOnly = true;
      this.messageDialog = true;
    },
    openChannelFromList(channel) {
      this.menu = false;
      this.driverChannelSelected(channel);
    },
    openChatFromBeautifulChat() {
      this.openChat = true;
    },
    async fetchActiveDriverIds() {
      var url = `${this.$store.state.apiUrl}/chat/getChannelsForDrivers?onlineOnly=${this.onlineOnly}`;
      
      // console.log(url);
      
      let response = await axios.get(url, {
        params: {},
      });
      // this.showProgressBar = false
      
      if (response.data.error == "no_error") {
        var ids = response.data.channelSids;
        this.activeDriverIDS = ids;
        this.contactNumberMap = response.data.contactNumberMap
      }
    },
    async sendMessageToAllDrivers(message) {
      try {
        var url = `${this.$store.state.apiUrl}/chat/getChannelsForDrivers?onlineOnly=${this.onlineOnly}`;
        
        // console.log(url);
        
        let response = await axios.get(url, {
          params: {},
        });
        
        if (response.data.error == "no_error") {
          var ids = response.data.channelSids;
          console.log(ids);
          
          var tc = this.tc;
          
          for (var i = 0; i < this.tc.subscribedChannels.length; i++) {
            const lc = this.tc.subscribedChannels[i];
            
            var oldMessages =
              lc.lastMessage != null &&
              lc.lastReadMessage < lc.lastMessage.index;
            
            if (ids.indexOf(lc.sid) >= 0) {
              if (!oldMessages) {
                lc.sendMessage(message).then(function (m) {
                  lc.setAllMessagesRead();
                });
              }
            } else {
            }
          }
        } else {
          alert("Error sending to all drivers");
        }
        
        this.loading = false;
      } catch (error) {
        alert("Error sending to all drivers");
        this.loading = false;
      }
      
      this.messageDialog = false;
    },
    colorForChannel(c) {
      if (
        c.lastMessage != null &&
        c.lastReadMessageIndex < c.lastMessage.index
      ) {
        return "blue lighten-2";
      } else {
        return "grey lighten-2";
      }
    },
    driverChannelSelected(channel) {
      this.filter = "";
      
      var driverIDString = channel.uniqueName.replace(this.prefix, "");
      console.log(driverIDString);
      
      var driverID = Number(driverIDString);
      
      this.$store.state.driverToMessage = driverID;
    },
    closeChannel(channel) {
      for (var i = 0; i < this.tc.activeChannels.length; i++) {
        var activeChannel = this.tc.activeChannels[i];
        
        if (activeChannel.sid == channel.sid) {
          this.tc.activeChannels.splice(i, 1);
        }
      }
      
      if (
        this.tc.currentChannel != null &&
        this.tc.currentChannel.sid == channel.sid
      ) {
        this.closeChat();
      }
    },
    closeChat() {
      console.log("Closing Chat");
      this.openChat = false;
      this.$store.state.driverToMessage = null;
      var channel = this.tc.currentChannel;
      this.tc.currentChannel = null;
      
      // for (var i = 0; i < this.tc.activeChannels.length; i++) {
      //   var activeChannel = this.tc.activeChannels[i];
      
      //   if (activeChannel.sid == channel.sid) {
      //     this.tc.activeChannels.splice(i, 1);
      //   }
      // }
    },
    async fetchAccessToken() {
      // console.log("Fetch Access Token");
      try {
        var url = `${this.$store.state.apiUrl}/chat/getAuthToken`;
        
        let response = await axios.get(url, {
          params: {},
        });
        
        if (response.data.accessToken != null) {
          this.accessToken = response.data.accessToken;
          this.prefix = response.data.prefix;
          this.identity = response.data.identity;
          
          if (this.tc.messagingClient == null) {
            this.initialiseChat(this.accessToken);
          } else {
            this.setNewToken(this.accessToken);
          }
        } else {
          setTimeout(this.fetchAccessToken, 2000);
        }
        
        this.loading = false;
      } catch (error) {
        this.loading = false;
        
        setTimeout(this.fetchAccessToken, 2000);
      }
    },
    messageSent:async function (msg) {
      const message = await this.tc.currentChannel.prepareMessage().setBody(msg.data.text);
      message.setAttributes({sent_by: this.authUser.name});
      message.build().send()
    },
    async updateMessageAttributesByMessage(messageToUpdate) {
      try {
        const conversation = await this.tc.messagingClient.getConversationByUniqueName(this.prefix + this.driverToMessage);
        console.log("read receipts attempt to message update");
        console.log(conversation);
        
        this.tc.currentChannel = conversation;
        
        if (!this.tc.activeChannels.some(activeChannel => activeChannel.sid === conversation.sid)) {
          this.tc.activeChannels.push(conversation);
          console.log("read receipts Newly active channel");
        }
        
        // Fetch the message
        const messages = await conversation.getMessages(15);
        const message = messages.items.find(msg => msg.sid === messageToUpdate.sid);
        
        if (!message) {
          console.error('read receipts Message not found:');
          return;
        }
        
        // Merge the current attributes with the new attributes
        const updatedAttributes = { ...message.attributes, ...{seen_by: this.chatOpenedBy} };
        
        // Update the message attributes
        await message.updateAttributes(updatedAttributes);
        
        console.log('read receipts Message attributes updated:', message);
      } catch (error) {
        console.error('read receipts Error updating message attributes:', error);
      } finally {
        this.loadedChats = false;
      }
    },
    async addReadReceipt () {
      console.log('read receipts adding')
      try {
        const conversation = await this.tc.messagingClient.getConversationByUniqueName(this.prefix + this.driverToMessage);
        
        
        let lastMessage = '';
        if (this.twilioMessageList.length) {
          console.log('read receipts got twilio message length with length ' + this.twilioMessageList.length)
          lastMessage = this.twilioMessageList[this.twilioMessageList.length -1];
        }
        if (!lastMessage) {
          console.log('read receipts last message not found')
          return;
        }
        // Get the message to be updated
        const messages = await conversation.getMessages();
        const message = messages.items.find((msg) => msg.sid === lastMessage.sid);
        
        if (message) {
          console.log('read receipts Message found to update ', message);
        } else {
          console.log('read receipts Message not found');
        }
        
        console.log('Message attributes', message.attributes)
        // Update the message attributes with the seen_by property
        const messageAttributes = message.attributes;
        messageAttributes.seen_by = this.authUser.name;
        
        // Update the message with the new message body and attributes
        await message.updateAttributes({ attributes: messageAttributes });
      } catch (error) {
        console.error('Error updating message:', error);
      }
    },
    async updateLastMessageSeenBy (message) {
      console.log('read receipts adding')
      try {
        const messageAttributes = message.attributes;
        // messageAttributes.seen_by = this.authUser.name;
        console.log('read receipts message updating');
        // Update the message attributes
        await message.updateAttributes({ seen_by: 'ateeq' });
      } catch (error) {
        console.error('Read Receipts error updating message:', error);
      }
      // this.loadDriverChats(this.driverToMessage)
    },
    initialiseChat: function (token) {
      var tc = this.tc;
      
      // console.log("Initialising chat with access token " + token);
      
      var self = this;
      
      Twilio.Conversations.Client.create(token)
        .then(function (client) {
          // console.log("Connected to chat");
          tc.messagingClient = client;
          tc.messagingClient.on(
            "tokenAboutToExpire",
            self.refreshToken.bind(this)
          );
          tc.messagingClient.on("tokenExpired", self.refreshToken.bind(this));
          
          tc.messagingClient.on("messageAdded", function (m) {
            console.log(m);
            // if (m.author && m.author != self.identity) {
            //   self.updateLastMessageSeenBy(m)
            // }
            
            if (
              m.author != self.identity &&
              (self.tc.currentChannel == null ||
                m.conversation.sid != self.tc.currentChannel.sid)
            ) {
              var thissound = document.getElementById("ding");
              thissound.currentTime = 0;
              thissound.play();
            }
          });
          
          tc.messagingClient.on("conversationUpdated", function (cu) {
            console.log("Channel updated");
            var c = cu.conversation;
            console.log('log c', c);
            
            if (
              !(tc.currentChannel != null && tc.currentChannel.sid == c.sid)
            ) {
              console.log('c last message', c.lastMessage)
              console.log('c last read message index', c.lastReadMessageIndex)
              console.log('c last message index', c.lastMessage.index)
              
              if (
                c.lastMessage != null &&
                c.lastReadMessageIndex < c.lastMessage.index
              ) {
                console.log("UNREAD MESSAGES");
                
                if (
                  !self.tc.activeChannels.some(function (activeChannel) {
                    return activeChannel.sid == c.sid;
                  })
                ) {
                  
                  c.getMessages(1).then(function (messages) {
                    
                    console.log(messages);
                    
                    var ml = [];
                    
                    for (var i = 0; i < messages.items.length; i++) {
                      var msg = messages.items[i];
                      
                      if (msg.author == self.identity) {
                        // c.setAllMessagesConsumed();
                      } else {
                        self.tc.activeChannels.push(c);
                        console.log("Newly active channel");
                      }
                    }
                  });
                } else {
                  console.log("Channel already active");
                }
              } else {
                console.log(
                  "Channel update not about last message -- may have been clearing read messages so close unless open!"
                );
                console.log(
                  c.lastMessage.index + " " + c.lastReadMessage
                );
                
                for (var i = 0; i < tc.activeChannels.length; i++) {
                  const activeChannel = tc.activeChannels[i];
                  
                  if (activeChannel.sid == c.sid) {
                    tc.activeChannels.splice(i, 1);
                  }
                }
              }
            } else {
              console.log("Leave chat alone if currently open");
            }
          });
          
          tc.messagingClient.on("messageAdded", function (msg) {
            console.log("Message Added");
            console.log(msg);
            
            if (
              tc.currentChannel != null &&
              msg.conversation.sid == tc.currentChannel.sid
            ) {
              // if (msg.author && msg.author != self.identity) {
              //   self.updateLastMessageSeenBy(msg)
              // }
              self.messageList.push({
                author: msg.author == self.identity ? "me" : msg.author,
                type: "text",
                id: msg.sid,
                data: {
                  text: msg.body,
                  meta: self.getMetaString(msg),
                },
                index: msg.index,
              });
              
              console.log("All messages consumed");
              tc.currentChannel.setAllMessagesRead();
            }
          });
          tc.messagingClient.on("messageUpdated", function (msg) {
            console.log("Message Updated");
            console.log(msg);
            
            if (
              tc.currentChannel != null &&
              msg.conversation.sid == tc.currentChannel.sid
            ) {
              self.messageList.push({
                author: msg.author == self.identity ? "me" : msg.author,
                type: "text",
                id: msg.sid,
                data: {
                  text: msg.body,
                  meta: self.getMetaString(msg),
                },
                index: msg.index,
              });
              
              console.log("All messages consumed");
              tc.currentChannel.setAllMessagesRead();
            }
          });
          
          // get list of all subscribed channels
          client.getSubscribedConversations().then(function (paginator) {
            self.fetchChannels(paginator);
          });
          // listen for events on all of these channels
          // when added to a channel subscribe to it (new drivers for example)
          //
        })
        .catch(function (e) {
          console.log("Error Starting Twilio");
          console.log(e);
        });
    },
    fetchChannels(paginator) {
      for (var i = 0; i < paginator.items.length; i++) {
        var channel = paginator.items[i];
        
        this.tc.subscribedChannels.push(channel);
        
        if (channel.lastMessage == null) {
          // console.log("LAST MESSAGE NULL");
        }
        
        if (
          channel.lastMessage != null &&
          channel.lastMessage.index >
          channel.lastReadMessage
        ) {
          
          var self = this;
          
          channel.getMessages(1).then(function (messages) {
            
            console.log(messages);
            
            var ml = [];
            
            for (var i = 0; i < messages.items.length; i++) {
              var msg = messages.items[i];
              
              if (msg.author == self.identity) {
                channel.setAllMessagesRead();
              } else {
                self.tc.activeChannels.push(channel);
              }
            }
          });
        }
      }
      
      var self = this;
      var tc = this.tc;
      
      if (paginator.hasNextPage) {
        // console.log("Paginator has next page so fetch");
        paginator.nextPage().then(function (p) {
          // console.log("Next page");
          // console.log(p);
          self.fetchChannels(p);
        });
      } else {
        // console.log("Paginator fully iterated");
        
        
        self.tc.localChannels = self.tc.subscribedChannels;
      }
    },
    refreshToken() {
      console.log("Token about to expire");
      this.fetchAccessToken();
    },
    setNewToken(token) {
      var self = this;
      console.log("Setting new token " + token);
      console.log(this.tc.messagingClient);
      this.tc.messagingClient
        .updateToken(token)
        .then(function (success) {
          console.log("Refreshed Access Token");
        })
        .catch(function (e) {
          console.log("Error refreshing token -- attempt getting new one");
          setTimeout(function () {
            self.fetchAccessToken();
          }, 1500);
        });
    },
  },
};
</script>

<style lang="scss">
// #main {
//   margin-left: 14px;
// }

.v-content {
  background-color: #f2f3f8;
}

#whoLogged {
  position: absolute;
  float: right;
  top: 24px;
  right: 24px;
  color: gray;
}

aside {
  box-shadow: none !important;
}

tbody tr:nth-of-type(even) {
  background-color: white;
}

p {
  padding: 0 !important;
  margin: 0 !important;
}

.add-person-button {
  padding-top: 4px;
  padding-left: 2px;
}

table.v-table thead th:first-child {
  padding: 0 4px !important;
}

table.v-table thead th:not(:first-child) {
  padding: 0 4px !important;
}

tr {
  border: 1px solid white;
  border-bottom: 0;
}

.v-date-picker-table {
  position: relative;
  padding: 0 12px;
  height: 300px !important;
}

.row {
  margin-left: 0px !important;
  margin-right: 2px !important;
}

.input-group.input-group--error label {
  animation: none !important;
}

a:link {
  text-decoration: none;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0 !important;
}

input[type=number] {
  -moz-appearance: textfield !important;
}

.btn {
  text-transform: unset !important;
}

.v-label {
  font-size: 12px !important;
}


.input-text {
  ::v-deep {
    .v-text-field {
      input {
        color: blue !important;
      }
    }
  }
}
</style>
